import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../../elements/RenderErrors';
import ButtonGroupSelection from '../../elements/ButtonGroupSelection';
import store from '../../../services/store';
import helpers from '../../../services/helpers';
import { getApiData } from '../../../services/apiService';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
 
export default function PermissionFormModal ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Permission",
        src="customer",
        store_id="",
        index="",
        member_data={},
        direct_save
    }){
    let default_data = {
        "id": "",
        "name":"",
        "description":"",
        "display_name": "",
        "group": ""
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [form_data, setFormData] = useState(default_data);
    const [form_loaded, setFormLoaded] = useState(0);
    const [errors, setErrors] = useState([]);
   
    useEffect(() => {
        setErrors([])
        
        // if(src=="store" && is_show) {
        //     fetchData()
        // }
        // else if(is_show && member_data) {
        //     setFormData(member_data)
        //     //fetchCities()
        // }
        // else{
        //     setFormData(default_data)
        //     //fetchCities()
        // }
        if(is_show && reference_id){
            fetchData()
        }
        else if(is_show){
            setFormData(member_data)
            //console.log('reference_id', reference_id)
        }
    }, [is_show]);
   
    useEffect(() => {
        setErrors([])
    }, [form_data]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createUrl(`V1/permissions/${reference_id}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setFormData(res)
            setLoading(0)
            setFormLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setFormData({ ...form_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!form_data.name){
            new_errors['name'] = ['The name field is required.']
        }
        else{
            delete new_errors['name'];
        }

        if(!form_data.description){
            new_errors['description'] = ['The description field is required.']
        }
        else{
            delete new_errors['description'];
        }

        if(!form_data.gender){
            new_errors['gender'] = ['The gender field is required.']
        }
        else{
            delete new_errors['gender'];
        }

        if(form_data.age === null || form_data.age === undefined || form_data.age === ""){
            new_errors['age'] = ['The age field is required.']
        }
        else{
            delete new_errors['age'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    // function handleSubmit(e) {
    //     // const validate = validateForm();
    //     // if(Object.keys(validate).length){
    //     //     toast.current.show({severity:'error', detail:'Please complete all required fields in the form.', life: 5000});
    //     //     return
    //     // }

    //     setShow(0);
    //     let form_data = {...form_data}
    //     if(reference_id){
    //         form_data.flag = 'edit'
    //     }

    //     handleSave(form_data, index)
        
    // }



    function handleSubmit(e) {
        setLoading(1)

        let url = helpers.createUrl(`V1/permissions/create`)
        if(reference_id && form_loaded){
            url = helpers.createUrl(`V1/permissions/${reference_id}`)
        }

        httpRequest(url, 'POST', {
            postdata: form_data,
        }, true)
            .then((res) => {
                form_data.id = res.id
                setLoading(0)
                toast.current.show({severity:'success', detail:res.message, life: 20000});

                setShow(0);
                handleSave(form_data)
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                toast.current.show({severity:'error', detail:err.message, life: 5000});
            }); 
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setFormData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Save" className='rounded' icon="fas fa-check" onClick={(e) => handleSubmit(1)} autoFocus />
        </div>
    );

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <Dialog 
                visible={is_show} 
                position="top" 
                header={reference_id ? 'Permission' : 'New Permission'} 
                style={{ width: '40vw' }} 
                breakpoints={{ 
                    '960px': '40vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <label>Name<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="name" 
                                name="name" 
                                value={form_data.name}
                                tagClass="form-control mb-0"
                                placeholder="Name"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <label>Display<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="display_name" 
                                name="display_name" 
                                value={form_data.display_name}
                                tagClass="form-control mb-0"
                                placeholder="Display Name"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="display_name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <label>Group<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="group" 
                                name="group" 
                                value={form_data.group}
                                tagClass="form-control mb-0"
                                placeholder="Group"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="group" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-md-4">
                            <label>Description<span className="text-danger"></span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputTextarea
                                id="description" 
                                name="description" 
                                value={form_data.description}  
                                onChange={inputChange}
                                rows={4}
                                className='w-100 form-controls'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="description" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div> */}
            </Dialog>
        </>
    )
}